
import axios from "../utils/axios";
import { apis } from "../constants/apis";
import httpService from "./httpService";
import { getApiUrl } from "../helpers/common";

// Giỏ hàng qua core CBD: `REACT_APP_API_BASE_URL` + `/${REACT_APP_API_SERVICE_PREFIX}` (`/cbd/api/v1/carts/...`), không qua
// VMRS microservice (`vmrs*`). Thêm / xoá / đọc giỏ PHẢI cùng một service, kẻo ảnh vừa thêm không hiện trong giỏ.

export async function addImgIntoCart(payload: any)
{
  return axios.post(await getApiUrl(apis.cart.addImage), payload);
}

export async function delImgIntoCart(payload: any)
{
  return axios.delete(await getApiUrl("/api/v1/carts/remove/items"), { data: payload });
}

export async function getImgs(payload: any)
{
  return axios.get(await getApiUrl(apis.cart.getImage), payload);
}

export async function getProductBundleByItemType(payload: any)
{
  return httpService.get(
    `${apis.cart.getProductBunbleByItemType}/${payload?.itemType}`
  );
}
